// src/Nosotros.tsx
import React from 'react';
import AnimationWrapper from './AnimationWrapper';

// === DATOS DEL EQUIPO (Se mantienen igual) ===
const EQUIPO_BESTUNE = [
    { 
        nombre: "María Solano", 
        cargo: "Directora Ejecutiva (CEO)", 
        descripcion: "Visionaria detrás de la expansión de Bestune, enfocada en traer innovación automotriz al país.",
        fotoPlaceholder: "👩🏻‍💼"
    },
    { 
        nombre: "Javier Ríos", 
        cargo: "Gerente de Servicios", 
        descripcion: "Experto en mecánica de alta gama, garantiza que cada vehículo salga perfecto del taller.",
        fotoPlaceholder: "👨🏻‍🔧"
    },
    { 
        nombre: "Andrea Lugo", 
        cargo: "Líder de Ventas", 
        descripcion: "Especialista en financiamiento y atención al cliente. Tu aliada para conseguir el auto ideal.",
        fotoPlaceholder: "👩🏻‍💻"
    },
    { 
        nombre: "Luis Mendoza", 
        cargo: "Jefe de Taller", 
        descripcion: "Certificado internacionalmente en motores turbo y sistemas híbridos.",
        fotoPlaceholder: "👨🏻‍🔬"
    },
];

// === DATOS DE VENTAJAS DEL DEALER (NUEVO) ===
const VENTAJAS = [
    {
        titulo: "Stock Garantizado",
        desc: "Disponibilidad inmediata en modelos nuevos y una selección premium de usados certificados.",
        icono: "🚗"
    },
    {
        titulo: "Financiamiento a Medida",
        desc: "Alianzas con los principales bancos para ofrecerte tasas preferenciales y aprobación rápida.",
        icono: "📝"
    },
    {
        titulo: "Servicio Post-Venta",
        desc: "Taller especializado con repuestos originales y técnicos certificados por la marca.",
        icono: "🛠️"
    },
    {
        titulo: "Retoma de Vehículos",
        desc: "Aceptamos tu vehículo actual como parte de pago con el avalúo más competitivo del mercado.",
        icono: "🔄"
    }
];

// === ESTADÍSTICAS (NUEVO - Trust Signals) ===
const ESTADISTICAS = [
    { numero: "+12", etiqueta: "Años de Experiencia" },
    { numero: "+5k", etiqueta: "Vehículos Vendidos" },
    { numero: "100%", etiqueta: "Garantía Real" },
    { numero: "3", etiqueta: "Sedes Nacionales" },
];

const Nosotros: React.FC = () => {
    return (
        <div className="min-h-screen bg-white text-gray-800 font-sans">
            
            {/* === 1. HERO SECTION (Estilo Parallax Premium) === */}
            <div 
                className="relative h-[60vh] bg-fixed bg-cover bg-center flex items-center justify-center" 
                style={{ backgroundImage: `url('/Consecionario-2.webp')` }} // Asegúrate de tener esta imagen o usa una genérica
            >
                <div className="absolute inset-0 bg-black/60"></div>
                <div className="relative z-10 text-center px-4 max-w-4xl mx-auto">
                    <AnimationWrapper direction="up">
                        <span className="text-yellow-500 font-bold tracking-[0.2em] uppercase text-sm md:text-base mb-2 block">
                            Bienvenido a Bestune Cars
                        </span>
                        <h1 className="text-5xl md:text-7xl font-extrabold text-white mb-6 leading-tight">
                            Redefiniendo el <br/> <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-yellow-600">Lujo Accesible</span>
                        </h1>
                    </AnimationWrapper>
                </div>
            </div>

            {/* === 2. HISTORIA (Diseño Split: Imagen Izq / Texto Der) === */}
            <div className="py-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
                    
                    {/* Imagen Decorativa */}
                    <AnimationWrapper direction="left">
                        <div className="relative">
                            <div className="absolute -top-4 -left-4 w-full h-full border-4 border-yellow-600 z-0"></div>
                            <img 
                                src="/Imagen1.webp" // Puedes reusar una imagen de carro o showroom
                                alt="Showroom Bestune" 
                                className="relative z-10 shadow-2xl w-full h-[500px] object-cover filter brightness-90 contrast-110"
                            />
                            <div className="absolute bottom-10 -right-6 bg-black text-white p-6 shadow-xl z-20 max-w-xs hidden md:block">
                                <p className="font-bold text-lg">"No vendemos autos, entregamos sueños sobre ruedas."</p>
                                <p className="text-yellow-500 text-sm mt-2">- María Solano, CEO</p>
                            </div>
                        </div>
                    </AnimationWrapper>

                    {/* Texto Corporativo (Fusión de Misión/Visión) */}
                    <AnimationWrapper direction="right">
                        <div>
                            <h2 className="text-4xl font-extrabold text-black mb-6">
                                Más que un Concesionario, <br/>
                                <span className="border-b-4 border-yellow-600">Tu Socio en el Camino.</span>
                            </h2>
                            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                                Fundada con la visión de transformar el mercado automotriz en Venezuela, <strong>Bestune Cars</strong> nació para llenar un vacío: ofrecer vehículos de alta gama, tecnología de punta y seguridad superior, pero con un respaldo real y precios competitivos.
                            </p>
                            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                                Nuestra misión va más allá de entregar llaves. Nos dedicamos a crear una experiencia de compra transparente, segura y emocionante, asegurando que cada cliente se sienta parte de una familia exclusiva desde el momento en que entra a nuestro showroom.
                            </p>
                            
                            <div className="grid grid-cols-2 gap-6">
                                <div className="pl-4 border-l-4 border-yellow-600">
                                    <h4 className="font-bold text-black text-xl">Innovación</h4>
                                    <p className="text-sm text-gray-500">Tecnología automotriz de última generación.</p>
                                </div>
                                <div className="pl-4 border-l-4 border-black">
                                    <h4 className="font-bold text-black text-xl">Respaldo</h4>
                                    <p className="text-sm text-gray-500">Garantía y repuestos asegurados.</p>
                                </div>
                            </div>
                        </div>
                    </AnimationWrapper>
                </div>
            </div>

            {/* === 3. BARRA DE ESTADÍSTICAS (Trust Signals) === */}
            <div className="bg-black py-16 text-white border-y border-gray-800">
                <div className="max-w-7xl mx-auto px-4">
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
                        {ESTADISTICAS.map((stat, index) => (
                            <AnimationWrapper key={index} direction="up" delay={index * 100}>
                                <div>
                                    <p className="text-5xl font-extrabold text-yellow-600 mb-2">{stat.numero}</p>
                                    <p className="text-lg text-gray-300 font-medium uppercase tracking-wide">{stat.etiqueta}</p>
                                </div>
                            </AnimationWrapper>
                        ))}
                    </div>
                </div>
            </div>

            {/* === 4. POR QUÉ ELEGIRNOS (Grid de Ventajas) === */}
            <div className="py-20 bg-gray-50">
                <div className="max-w-7xl mx-auto px-4 text-center">
                    <AnimationWrapper direction="up">
                        <h2 className="text-4xl font-extrabold text-black mb-12">
                            La Diferencia <span className="text-yellow-600">Bestune</span>
                        </h2>
                    </AnimationWrapper>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                        {VENTAJAS.map((item, index) => (
                            <AnimationWrapper key={index} direction="up" delay={index * 100}>
                                <div className="bg-white p-8 shadow-lg hover:shadow-xl transition-shadow duration-300 border border-gray-100 h-full flex flex-col items-center">
                                    <div className="w-16 h-16 bg-gray-100 flex items-center justify-center text-4xl mb-6 text-yellow-600">
                                        {item.icono}
                                    </div>
                                    <h3 className="text-xl font-bold text-gray-900 mb-3">{item.titulo}</h3>
                                    <p className="text-gray-500 text-sm leading-relaxed">
                                        {item.desc}
                                    </p>
                                </div>
                            </AnimationWrapper>
                        ))}
                    </div>
                </div>
            </div>

{/* === 5. NUESTRO EQUIPO EJECUTIVO (Diseño Dark Premium) === */}
            <div className="py-20 bg-black/95 relative overflow-hidden">
                
                {/* CAPA DE TEXTURA (Absolute para que quede al fondo) */}
                <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.webp')] opacity-10"></div>
                
                <div className="relative z-10 max-w-7xl mx-auto px-4">
                    <AnimationWrapper direction="up">
                        <div className="text-center mb-16">
                            {/* Texto cambiado a Blanco para contrastar con el fondo negro */}
                            <h2 className="text-4xl font-extrabold text-white mb-4">Conoce a los Expertos</h2>
                            <p className="text-gray-400 max-w-2xl mx-auto">
                                Un equipo multidisciplinario dedicado a brindarte la mejor asesoría en tu inversión.
                            </p>
                        </div>
                    </AnimationWrapper>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
                        {EQUIPO_BESTUNE.map((miembro, index) => (
                            <AnimationWrapper key={index} direction="up" delay={index * 150}>
                                <div className="group relative overflow-hidden shadow-xl">
                                    {/* Fondo de tarjeta (Imagen/Avatar) */}
                                    <div className="bg-gray-200 h-80 flex items-center justify-center relative border-b-4 border-yellow-600">
                                        {/* ELIMINADO: 'filter grayscale' para que tengan color siempre */}
                                        <div className="text-8xl transition duration-300 transform group-hover:scale-110">
                                            {miembro.fotoPlaceholder}
                                        </div>
                                        
                                        {/* Overlay al hacer hover */}
                                        <div className="absolute inset-0 bg-black/90 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col items-center justify-center p-6 text-center">
                                            <p className="text-gray-200 italic text-sm">"{miembro.descripcion}"</p>
                                            <button className="mt-4 text-yellow-500 text-sm font-bold underline hover:text-yellow-400">Contactar</button>
                                        </div>
                                    </div>
                                    
                                    {/* Info Pie */}
                                    <div className="bg-white pt-4 pb-4 text-center">
                                        <h3 className="text-lg font-bold text-black uppercase">{miembro.nombre}</h3>
                                        <p className="text-sm text-yellow-600 font-semibold">{miembro.cargo}</p>
                                    </div>
                                </div>
                            </AnimationWrapper>
                        ))}
                    </div>
                </div>
            </div>

            {/* === 6. CALL TO ACTION (CTA) === */}
            <div className="relative py-24 bg-white overflow-hidden">
                {/* Decoración de fondo */}
                <div className="absolute top-0 left-0 w-full h-full"></div>
                
                <div className="relative z-10 max-w-4xl mx-auto px-4 text-center">
                    <AnimationWrapper direction="up">
                        <h2 className="text-4xl md:text-5xl font-extrabold text-black mb-6">
                            ¿Listo para vivir la experiencia?
                        </h2>
                        <p className="text-xl text-gray-400 mb-10">
                            Visita nuestro showroom y agenda tu prueba de manejo hoy mismo.
                        </p>
                        <div className="flex flex-col md:flex-row justify-center gap-4">
                            <button className="bg-yellow-600 text-gray-200 font-bold py-4 px-10 hover:bg-yellow-700 transition duration-300 text-lg shadow-lg shadow-yellow-600/20">
                                Agendar Cita
                            </button>
                            <button className="bg-transparent border-2 border-black/95 text-gray-400 font-bold py-4 px-10 hover:bg-gray-400 hover:text-black transition duration-300 text-lg">
                                Ver Inventario
                            </button>
                        </div>
                    </AnimationWrapper>
                </div>
            </div>
        </div>
    );
};

export default Nosotros;